export const trustedByTranslations = {
  en: {
    title: "Trusted By"
  },
  fr: {
    title: "Approuvé par"
  }
}